/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import { EuiCallOut, EuiSpacer } from '@elastic/eui'

import { DEFAULT_TRIAL_DAYS } from '@modules/profile-lib/trial'

import { billingOverviewUrl } from '../../../../apps/userconsole/urls'

import type { FunctionComponent } from 'react'

interface Props {
  days?: number | undefined
}

const TrialLimitMessage: FunctionComponent<Props> = ({ days = DEFAULT_TRIAL_DAYS }) => (
  <Fragment>
    <EuiCallOut
      data-test-id='trial-maxed-out'
      title={
        <FormattedMessage
          id='create-deployment.inTrial.title-ma'
          defaultMessage='Maximum deployments reached'
        />
      }
    >
      <FormattedMessage
        id='create-deployment.inTrial.description'
        defaultMessage='Your {days}-days trial includes one deployment to start your Elasticsearch journey. Add your {billingDetails} to create multiple deployments or delete your existing deployment to make a new trial deployment.'
        values={{
          billingDetails: (
            <Link to={billingOverviewUrl()}>
              <FormattedMessage
                id='create-deployment.inTrial.billing-details'
                defaultMessage='billing details'
              />
            </Link>
          ),
          days,
        }}
      />
      <EuiSpacer size='m' />
      <FormattedMessage
        id='create-deployment.inTrial.description-deleted'
        defaultMessage='Deleted but still seeing this message? Wait a few moments and refresh the page.'
      />
    </EuiCallOut>
    <EuiSpacer size='m' />
  </Fragment>
)

export default TrialLimitMessage
